module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Component Age(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'significantPeriodList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ageSelection', {
    ref: "ageSelection",
    attrs: {
      "isPrehistoric": true,
      "parentFormName": _vm.qaqcFieldId + 'pff'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Features")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'assemblageDetailsList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "well row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.featureList.filter(function (x) {
    return x.featureId < 9
  })), function(feature) {
    return _c('li', [_c('form', {
      staticClass: "form-inline inline-container"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedList),
        expression: "selectedList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'PrehistoricFeature' + feature.featureId
      },
      domProps: {
        "value": feature.featureId,
        "checked": Array.isArray(_vm.selectedList) ? _vm._i(_vm.selectedList, feature.featureId) > -1 : (_vm.selectedList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = feature.featureId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'PrehistoricFeature' + feature.featureId
      }
    }, [_vm._v(_vm._s(feature.description))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (feature.hasCount && _vm.selectedList.includes(feature.featureId)),
        expression: "feature.hasCount && selectedList.includes(feature.featureId)"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.countList[feature.featureId]),
        expression: "countList[feature.featureId]"
      }],
      staticClass: "form-control inline-input",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "count"
      },
      domProps: {
        "value": (_vm.countList[feature.featureId])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.countList, feature.featureId, $event.target.value)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.featureList.filter(function (x) {
    return x.featureId >= 9 && x.featureId <= 16
  })), function(feature) {
    return _c('li', [_c('form', {
      staticClass: "form-inline inline-container"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedList),
        expression: "selectedList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'pf' + feature.featureId
      },
      domProps: {
        "value": feature.featureId,
        "checked": Array.isArray(_vm.selectedList) ? _vm._i(_vm.selectedList, feature.featureId) > -1 : (_vm.selectedList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = feature.featureId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'pf' + feature.featureId
      }
    }, [_vm._v(_vm._s(feature.description))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (feature.hasCount && _vm.selectedList.includes(feature.featureId)),
        expression: "feature.hasCount && selectedList.includes(feature.featureId)"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.countList[feature.featureId]),
        expression: "countList[feature.featureId]"
      }],
      staticClass: "form-control inline-input",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "count"
      },
      domProps: {
        "value": (_vm.countList[feature.featureId])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.countList, feature.featureId, $event.target.value)
        }
      }
    })])])
  }))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assemblageDto.keywords),
      expression: "assemblageDto.keywords"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.assemblageDto.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assemblageDto, "keywords", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'keywords',
      "hasAppend": true
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Feature Inventory")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'prehistoricFeatureInventoryList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.inventoryList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.featureNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.featureDescription))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.removeInventory(index)
        }
      }
    })])])
  }))])], 1)]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-10"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['inventoryModal'].open()
      }
    }
  }, [_vm._v("Add Inventory")])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "inventoryModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Feature Inventory Entry")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['inventoryModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Feature Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventoryDto.featureNumber),
      expression: "inventoryDto.featureNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inventoryDto.featureNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventoryDto, "featureNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventoryDto.featureDescription),
      expression: "inventoryDto.featureDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.inventoryDto.featureDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventoryDto, "featureDescription", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.inventoryDone()
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3 pull-right",
    attrs: {
      "name": "buttonMore"
    },
    on: {
      "click": function($event) {
        _vm.inventoryMore()
      }
    }
  }, [_vm._v("More")])])])]), _vm._v(" "), (!(_vm.formDisabled || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.savePrehistoricFeature
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'prehistoricFeature',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Feature Number")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a37af7b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/PrehistoricFeatureForm.vue
// module id = 981
// module chunks = 1